import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

export const PANEL_ID = 'poster-editor-transcript-letter-case-panel';

export const openPosterEditorTranscriptLetterCaseModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_TRANSCRIPT_LETTER_CASE_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
